import { FC, useCallback } from "react";

// styles
import styles from "./squareTab.module.scss";

type TSquareTabProps = {
    title: string,
    isActive: boolean,
    extraClassName?: string,
    extraClassNameActiveTab?: string,
    setSelectedTabIndex: () => void
};

export const SquareTab: FC<TSquareTabProps> = ({title, isActive, extraClassName, extraClassNameActiveTab, setSelectedTabIndex} : TSquareTabProps) => {

    const getClassName = (): string => {
        const classNameList = [styles.squareTab];
        if(extraClassName) classNameList.push(extraClassName);
        if(isActive) {
            if(!extraClassNameActiveTab) {
                classNameList.push(styles.active);
            } else {
                classNameList.push(extraClassNameActiveTab);
            }
        }
        const className = classNameList.join(" ");                
        return className;
    };

    const onTabClick = useCallback(() => {
        setSelectedTabIndex();
    }, [setSelectedTabIndex]);

    return (
        <div onClick={onTabClick} className={getClassName()}>
            <span>{title}</span>
        </div>
    );
};